import React, { useEffect, useState } from "react";
import { AdminPanelPage } from "../AdminPanelPage";
import { useParams } from "react-router-dom";
import { DashboardWithComponents, useDashboards } from "../../Contexts/DashboardsContext";
import { useAsyncEffect } from "../../Hooks/AsyncEffect";
import { Heading } from "@aidkitorg/component-library";

export const DashboardPage = () => {
  const { dashboard_id } = useParams<{ dashboard_id: string }>()

  const [dashboard, setDashboard] = useState<DashboardWithComponents>()

  const { fetchDashboardById, getDashboardById } = useDashboards()

  useAsyncEffect(async () => {
    await fetchDashboardById(dashboard_id)
  }, [])

  useEffect(() => {
    const dashboardWithComponents = getDashboardById(dashboard_id)
    if (dashboardWithComponents) {
      setDashboard(dashboardWithComponents)
    }
  }, [getDashboardById])

  return <AdminPanelPage 
    title={dashboard?.title || ''}
    description={dashboard?.description}
  >
    {dashboard?.components.map((component, idx) => (
      <div className="border" key={idx}>
        {JSON.stringify(component)}
      </div>
    ))}
  </AdminPanelPage>
}